import $ from "jquery";
import ko from "knockout";
import "flow/bindings/dateBindingV2";
import dateHelper from "flow/utils/dateHelper";
import register from "flow/knockout/register";

function setup() {
    register.registerKnockoutBinding("endDate", {
        init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            ko.bindingHandlers.datev2.init(
                element,
                function () {
                    return valueAccessor().end;
                },
                allBindingsAccessor,
                viewModel,
                bindingContext
            );
            const observable = valueAccessor();
            const startDateObservable = observable.start;
            const endDateObservable = observable.end;
            const daysAfterStartDate = observable.daysAfterStartDate;
            const defaultMinDate = new Date(-999999999999999);

            valueAccessor().end = ko.computed(function () {
                const startDate = startDateObservable();
                let minDate = $(element).datepicker("option", "minDate");
                const currDate = endDateObservable();

                if (dateHelper.isValidDateFormat(startDate) && minDate !== dateHelper.addDays(startDate, 1)) {
                    minDate = dateHelper.addDays(startDate, daysAfterStartDate);
                } else if (!dateHelper.isValidDateFormat(startDate) && minDate !== defaultMinDate) {
                    minDate = defaultMinDate;
                }
                $(element).datepicker("option", "minDate", minDate);

                //if (dateHelper.isValidDateFormat(currDate) && dateHelper.toDate(minDate) > dateHelper.toDate(currDate)) {
                //    currDate = minDate;
                //}

                $(element).val(currDate);
                $(element).trigger("change");
                endDateObservable.valueHasMutated();
                return endDateObservable();
            });
            endDateObservable.clearError();
        },
        update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            ko.bindingHandlers.datev2.update(
                element,
                function () {
                    return valueAccessor().end;
                },
                allBindingsAccessor,
                viewModel,
                bindingContext
            );
        }
    });
}

export default {
    setup: setup
};
